var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "#1A1A1A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 9.3335H14C10.6667 9.3335 9.33333 10.6668 9.33333 14.0002V18.0002C9.33333 21.3335 10.6667 22.6668 14 22.6668H18C21.3333 22.6668 22.6667 21.3335 22.6667 18.0002V16.6668",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6933 10.013L13.44 15.2663C13.24 15.4663 13.04 15.8597 13 16.1463L12.7133 18.153C12.6067 18.8797 13.12 19.3863 13.8467 19.2863L15.8533 18.9997C16.1333 18.9597 16.5267 18.7597 16.7333 18.5597L21.9867 13.3063C22.8933 12.3997 23.32 11.3463 21.9867 10.013C20.6533 8.67968 19.6 9.10635 18.6933 10.013Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.94 10.7666C18.3867 12.3599 19.6333 13.6066 21.2333 14.0599",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.1f7709dd6829fe8f2acc0fddb2f6c44c.svg";
export { ForwardRef as ReactComponent };